export const GET_ALL_SPECIALIZATIONS_FROM_ELEKS = "GET_ALL_SPECIALIZATIONS_FROM_ELEKS";

